import Vue from 'vue'
import AuctionLanding from './AuctionLanding.vue'
import axios from 'axios'
import Spinner from 'vue-simple-spinner'
import Multiselect from 'vue-multiselect'

import '@/assets/css/tailwind.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.component('vue-simple-spinner', Spinner)
Vue.component('multiselect', Multiselect)

Vue.prototype.filterRingDivisions = function (showBook, ringID, ringSettings) {
  if (ringSettings) {
    if (ringSettings.length > 1) {
      let ring = null
      if (ringID) {
        if (ringID !== 'All Rings') {
          ringSettings.forEach(r => {
            if (r.name === ringID) {
              ring = r
            }
          })
        }
      } else {
        ring = ringSettings[0]
      }
      if (ring) {
        showBook = showBook.filter(c => {
          // Filter based on if a ring_id is set
          if (c.ring_id) {
            return c.ring_id === ringID
          } else {
            return ring.divisions.includes(c.division)
          }
        })
      }
    }
  }
  return showBook
}

new Vue({
  render: h => h(AuctionLanding)
}).$mount('#app')
